import apiClient from '../../services/apiClient';
import { downloadCsv } from '../../lib/downloadBlob';
import type { ConsentScope, PromptKey, Testimonial, TestimonialForInstructor } from './types';

export interface CreateTestimonialInput {
  prompt_key: PromptKey;
  body: string;
  consent_scope: ConsentScope;
  display_name_ok: boolean;
}

export async function createTestimonial(input: CreateTestimonialInput): Promise<Testimonial> {
  const { data } = await apiClient.post('/api/v1/testimonials', input);
  return data.testimonial;
}

export async function listMyTestimonials(): Promise<Testimonial[]> {
  const { data } = await apiClient.get<{ testimonials: Testimonial[] }>('/api/v1/testimonials/me');
  return data.testimonials;
}

export interface ConsentPatch {
  consent_scope?: ConsentScope;
  display_name_ok?: boolean;
  revoke?: true;
}

export async function updateTestimonialConsent(id: string, patch: ConsentPatch): Promise<Testimonial> {
  const { data } = await apiClient.put(`/api/v1/testimonials/${id}/consent`, patch);
  return data.testimonial;
}

// Instructor ------------------------------------------------------------------

export async function listAllTestimonials(): Promise<TestimonialForInstructor[]> {
  const { data } = await apiClient.get<{ testimonials: TestimonialForInstructor[] }>('/api/v1/testimonials');
  return data.testimonials;
}

export async function updateTestimonialStatus(
  id: string,
  status: 'submitted' | 'approved',
): Promise<TestimonialForInstructor> {
  const { data } = await apiClient.put(`/api/v1/testimonials/${id}/status`, { status });
  return data.testimonial;
}

export async function downloadTestimonialsCsv(scope: 'marketing' | 'named_public'): Promise<void> {
  await downloadCsv(`/api/v1/testimonials/export.csv?scope=${scope}`, `testimonials-${scope}.csv`);
}
